<template>
  <div class="order-search-container">
    <div class="searchArea">
      <div style="display: flex; align-items: center;">
        <a-select v-model:value="searchParams.keyType" style="width: 120px; margin-right: 8px;" @change="handleKeyTypeChange">
          <a-select-option value="orderNo">订单号</a-select-option>
          <a-select-option value="uuid">UUID</a-select-option>
          <a-select-option value="customerName">用户姓名</a-select-option>
          <a-select-option value="afterSalesQo">订单状态</a-select-option>
        </a-select>

        <a-input v-if="searchParams.keyType !== 'afterSalesQo'" v-model:value="searchParams.keyValue" placeholder="关键字搜索" style="width: 180px; margin-right: 16px;" allowClear @pressEnter="handleSearch" />
        <a-select v-else v-model:value="searchParams.keyValue" placeholder="请选择状态" style="width: 180px; margin-right: 16px;" allowClear>
          <a-select-option value="">全部售后</a-select-option>
          <a-select-option value="售后中">售后中</a-select-option>
          <a-select-option value="售后完成">售后完成</a-select-option>
          <a-select-option value="无售后">无售后</a-select-option>
        </a-select>

        <a-select v-model:value="searchParams.timeType" style="width: 120px; margin-right: 8px;">
          <a-select-option value="createdDate">下单时间</a-select-option>
          <a-select-option value="payDate">支付时间</a-select-option>
        </a-select>
        <a-range-picker v-model:value="searchParams.dateRange" style="margin-right: 16px; width: 260px;" :placeholder="['开始时间','结束时间']" />

        <a-button type="primary" shape="circle" @click="handleSearch">
          <template #icon>
            <SearchOutlined /></template>
        </a-button>
        <a-button style="margin-left: 8px;" @click="resetSearch">重置</a-button>
      </div>
    </div>

    <a-tabs v-model:activeKey="searchParams.status">
      <a-tab-pane key="all" tab="全部" />
      <a-tab-pane key="待支付" tab="待支付" />
      <a-tab-pane key="已支付" tab="已支付" />
      <a-tab-pane key="已发货" tab="已发货" />
      <a-tab-pane key="已完成" tab="已完成" />
      <a-tab-pane key="已取消" tab="已取消" />
      <a-tab-pane key="已退款" tab="已退款" />
      <!-- <a-tab-pane key="售后中" tab="售后中" /> -->
    </a-tabs>

    <a-table :columns="columns" :data-source="filteredTableData" :loading="loading" class="ant-table-striped" :row-key="record => record.uuid" :scroll="{ x: 1100 }" :pagination="{ showTotal: (total) => `共 ${total} 条` }">
      <template v-for="col in ['orderNo', 'amount', 'createdDate', 'payDate']" #[col]="{ text, record }" :key="col">
        <div>
          <a-input v-if="editableData[record.uuid]" v-model:value="editableData[record.uuid][col]" style="margin: -5px 0" />
          <template v-else>{{ text || '--' }}</template>
        </div>
      </template>

      <template #customer="{ record }">
        <div>{{ record.customer?.name || '--' }}</div>
      </template>

      <template #status="{ text }">
        <a-tag :color="text === '待支付' ? 'orange' : 'blue'">{{ text || '--' }}</a-tag>
      </template>

      <template #action="{ record }">
        <a-space>
          <a-button type="link" size="small" @click="goDetail(record)">查看</a-button>
        </a-space>
      </template>
    </a-table>
  </div>

  <orderDetail v-model:visible="detailVisible" :uuid="currentUuid" />
</template>

<script>
import { SearchOutlined } from '@ant-design/icons-vue';
import { GetOrderList } from '@/api/order';
import orderDetail from '@/components/order/orderDetail.vue';

export default {
  components: { SearchOutlined, orderDetail },
  data() {
    return {
      loading: false,
      allTableData: [],
      editableData: {},
      searchParams: {
        keyType: 'orderNo',
        keyValue: '',
        timeType: 'createdDate',
        dateRange: [],
        status: 'all',
      },
      detailVisible: false,
      currentUuid: '',
      columns: [
        { title: '订单号', dataIndex: 'orderNo', width: 180, slots: { customRender: 'orderNo' } },
        { title: '金额', dataIndex: 'amount', width: 120, slots: { customRender: 'amount' } },
        { title: '状态', dataIndex: 'status', width: 100, slots: { customRender: 'status' } },
        { title: '客户', key: 'customer', width: 150, slots: { customRender: 'customer' } },
        { title: '下单时间', dataIndex: 'createdDate', width: 180, slots: { customRender: 'createdDate' } },
        { title: '支付时间', dataIndex: 'payDate', width: 180, slots: { customRender: 'payDate' } },
        { title: '操作', key: 'action', width: 120, fixed: 'right', slots: { customRender: 'action' } }
      ]
    };
  },
  computed: {
    filteredTableData() {
      if (this.searchParams.status === 'all') return this.allTableData;
      return this.allTableData.filter(item => item.status === this.searchParams.status);
    }
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    // 处理搜索类型切换
    handleKeyTypeChange() {
      // 切换类型时，清空之前填写的关键字/选择的状态，避免数据混乱
      this.searchParams.keyValue = '';
    },
    async handleSearch() {
      this.loading = true;
      try {
        const params = {};
        if (this.searchParams.keyValue) {
          params[this.searchParams.keyType] = this.searchParams.keyValue;
        }

        if (this.searchParams.dateRange?.length === 2) {
          params.periodName = this.searchParams.timeType;
          params.dateFrom = this.searchParams.dateRange[0].format('YYYY-MM-DD');
          params.dateTo = this.searchParams.dateRange[1].format('YYYY-MM-DD');
        }

        console.log('查询参数:', params);
        const res = await GetOrderList(params);
        if (res.errCode === 0) {
          this.allTableData = res.data || [];
        }
      } catch (error) {
        console.error(error);
        this.$message.error('数据加载失败');
      } finally {
        this.loading = false;
      }
    },
    resetSearch() {
      this.searchParams = {
        keyType: 'orderNo',
        keyValue: '',
        timeType: 'createdDate',
        dateRange: [],
        status: 'all'
      };
      this.handleSearch();
    },
    goDetail(record) {
      if (record?.uuid) {
        this.currentUuid = record.uuid;
        this.detailVisible = true;
      } else {
        this.$message.warning('订单数据异常');
      }
    }
  }
};
</script>

<style scoped>
.order-search-container {
  background: #fff;
}
</style>